<template>
  <a :href="link" class="map" target="_blank">
    <div class="map__wrapper">
      <LMap
        ref="map"
        :zoom="zoom"
        :center="[latitude, longitude]"
        :options="{ zoomControl: false, dragging: false, scrollWheelZoom: false }"
      >
        <LTileLayer
          :url="tileLayerUrl"
          attribution="&amp;copy; <a href=&quot;https://www.openstreetmap.org/&quot;>OpenStreetMap</a> contributors"
          layer-type="base"
          name="OpenStreetMap"
        />
        <l-marker :lat-lng="[latitude, longitude]">
          <l-icon icon-size="32" :icon-anchor="[16, 32]" icon-url="/location.svg" />
        </l-marker>
      </LMap>
    </div>
  </a>
</template>

<script setup lang="ts">
const zoom = ref(17)
const appConfig = useAppConfig()

const props = defineProps({
  style: {
    type: String,
    default: 'mapbox/light-v11'
  },
  longitude: {
    type: Number,
    required: true
  },
  latitude: {
    type: Number,
    required: true
  },
  link: {
    type: String,
    required: false,
    default: ''
  }
})

const tileLayerUrl: Ref<string> = computed(() => {
  return `https://api.mapbox.com/styles/v1/${props.style}/tiles/256/{z}/{x}/{y}@2x?access_token=${appConfig.credentials.mapbox.accessToken}`
})
</script>

<style lang="scss" scoped>
@use "~/assets/sass/tools";

.map {
  @include tools.page-grid-columns;
  position: relative;
  display: block;
  z-index: 0;

  &:hover {
    opacity: 1;
  }

  &__wrapper {
    @include tools.to(tools.$breakpoint--mobile) {
      aspect-ratio: 1 / 1;
    }
    @include tools.from(tools.$breakpoint--desktop) {
      aspect-ratio: 16 / 9;
    }
  }
}
</style>
